import { EntitledToView } from '@news-mono/web-common'
import React from 'react'
import {
    StyledPromoCard,
    StyledPromoImg,
    StyledPromoLink,
} from '../PromoCard.styled'

export const EntitledView = () => {
    const promo = require('../assets/retire-ready-logged-in.jpg')

    return (
        <StyledPromoCard promotion="retire-ready">
            <StyledPromoLink to="#your-money">
                <StyledPromoImg
                    src={promo}
                    alt="Personal finance news for you - Read now"
                />
            </StyledPromoLink>
        </StyledPromoCard>
    )
}
export const OpportunityView = () => {
    const promo = require('../assets/retire-ready-logged-out.jpg')

    return (
        <StyledPromoCard promotion="retire-ready">
            <StyledPromoLink
                to="https://subscriber.thewest.com.au"
                openExternalInNewWindow
            >
                <StyledPromoImg
                    src={promo}
                    alt="Get access to the episodes now - Find out how"
                />
            </StyledPromoLink>
        </StyledPromoCard>
    )
}

export const RetireReadyPromoCard = () => {
    return (
        <EntitledToView
            requiredAccess={{ level: 'subscriber' }}
            entitled={() => {
                return <EntitledView />
            }}
            notEntitled={() => {
                return <OpportunityView />
            }}
        />
    )
}
